import axios from 'axios';

import {
  filterRequestsUrl,
  requestHistoryUrl,
  countRequestsUrl,
  updateRequestNoteUrl,
  getDocumentsUrl,
  uploadImageUrl,
  uploadUnnaxDocumentsUrl,
  deleteImageUrl,
  updateRequestFieldUrl,
  archivedRequestsUrl,
  getRequestUrlByRequestId,
  expensesRequestUrl,
  RemoveExpensesRequestUrl,
  updateExpensesRequestUrl,
  userUrl,
  resetPasswordUrl,
  getPersonalReferencesUrl,
  getRepresentativeUrl,
  unnaxUrl,
  loanAppUrl,
  editImageName,
} from '../constants/endpointUrls';

import { LoanApplicationStatus } from '../constants/RequestStatus';

const { post, get, patch, put } = axios;

const filterRequests = params => post(filterRequestsUrl, params);

const getExpenses = requestId => get(expensesRequestUrl(requestId));
const addExpenses = (requestId, params) =>
  post(expensesRequestUrl(requestId), params);
const removeExpenses = (requestId, expensesId) =>
  axios.delete(RemoveExpensesRequestUrl(requestId, expensesId));
const requestExpenses = (requestId, params) =>
  put(expensesRequestUrl(requestId), params);
const updateExpense = ({ expenseList }) =>
  patch(updateExpensesRequestUrl, {
    expense: expenseList,
  });

const getRequestById = requestId => get(getRequestUrlByRequestId(requestId));

const updateRequest = (requestId, params) => {
  if (Object.hasOwnProperty.call(params, 'formsituacion')) {
    switch (params.formsituacion) {
      case LoanApplicationStatus.SIGNED.value:
        params.contract_sign_time = Date.now();
        break;
      case LoanApplicationStatus.DISBURSED.value:
        params.disbursement_time = Date.now();
        break;
      default:
        break;
    }
  }

  return patch(getRequestUrlByRequestId(requestId), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
};
const getRequestHistory = requestId => get(requestHistoryUrl(requestId));

const getRequestsCount = partner => {
  const params = new FormData();
  params.append('partner', partner);
  return post(countRequestsUrl, params);
};

const archiveRequest = requestId => {
  const params = new URLSearchParams();
  params.append('activo', 1);

  return patch(getRequestUrlByRequestId(requestId), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
};

const updateRequestStatus = (requestId, value) =>
  updateRequest(requestId, {
    formsituacion: value,
  });

const updateRequestNote = (
  requestId,
  noteText,
  isPrivate,
  activityType,
  user = null
) => {
  const note = user ? `${noteText}` : noteText;
  const params = new URLSearchParams();
  params.append('value', note);
  params.append('isPrivate', isPrivate);
  params.append('activityType', activityType);

  return post(updateRequestNoteUrl(requestId), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
};

const getDocuments = id => get(getDocumentsUrl(id));

const uploadImage = (data, loanId) =>
  post(uploadImageUrl(loanId), data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-type': 'multipart/form-data',
    },
  });

const uploadKycDocuments = formData =>
  post(uploadUnnaxDocumentsUrl(), formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-type': 'multipart/form-data',
    },
  });

const deleteImage = (id, fileName) =>
  axios.delete(deleteImageUrl(id, fileName));

const updateRequestField = (requestId, fieldName, fieldValue, inputs) => {
  const params = new URLSearchParams();
  params.append('id', requestId);
  params.append(fieldName, fieldValue);

  params.append('casa', inputs.casa);
  params.append('tiene_negocio', inputs.tiene_negocio);
  params.append('tiene_empleo', inputs.tiene_empleo);
  params.append('vehiculo', inputs.vehiculo);

  return post(updateRequestFieldUrl, params);
};

const getArchivedRequests = params => post(archivedRequestsUrl, params);

const requestResetPassword = userId =>
  post(`${userUrl(userId)}/requestResetPassword`, null, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-type': 'multipart/form-data',
    },
  });

const requestNewPassword = data => {
  const { token, password } = data;

  return post(resetPasswordUrl(token), {
    password,
  });
};

const getPersonalReferences = id =>
  get(getPersonalReferencesUrl(id), {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const createPersonalReference = params =>
  post(getPersonalReferencesUrl(''), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const updatePersonalReference = (personalReferenceId, params) =>
  patch(getPersonalReferencesUrl(personalReferenceId), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const deletePersonalReference = id =>
  axios.delete(getPersonalReferencesUrl(id), {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const getRepresentatives = id =>
  get(getRepresentativeUrl(id), {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const createRepresentative = params =>
  post(getRepresentativeUrl(''), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const updateRepresentative = (representativeId, params) =>
  patch(getRepresentativeUrl(representativeId), params, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const deleteRepresentative = id =>
  axios.delete(getRepresentativeUrl(id), {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

const editImageFileName = (fileName, renamedFileName) =>
  patch(editImageName(fileName, renamedFileName));

const updateUnnax = (id, kyc) =>
  axios.patch(
    unnaxUrl('update-unnax-response'),
    {
      formIbanOnlineId: id,
      response: kyc,
    },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }
  );

const createLoanApplication = loanApplication =>
  axios.post(loanAppUrl, loanApplication, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

export default {
  addExpenses,
  archiveRequest,
  createLoanApplication,
  createPersonalReference,
  createRepresentative,
  deleteImage,
  deletePersonalReference,
  deleteRepresentative,
  editImageFileName,
  filterRequests,
  getArchivedRequests,
  getDocuments,
  getExpenses,
  getPersonalReferences,
  getRepresentatives,
  getRequestById,
  getRequestHistory,
  getRequestsCount,
  removeExpenses,
  requestExpenses,
  requestNewPassword,
  requestResetPassword,
  updateExpense,
  updatePersonalReference,
  updateRepresentative,
  updateRequest,
  updateRequestField,
  updateRequestNote,
  updateRequestStatus,
  updateUnnax,
  uploadImage,
  uploadKycDocuments,
};



// WEBPACK FOOTER //
// ./src/utils/services/RequestsService.js